"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUnloadedFonts = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _constants = require("./constants");

var fontExists = function fontExists(fontString) {
  var exists = false;
  window.document.fonts.forEach(function (font) {
    if (!exists) {
      var fontCheck = [font.display, font.family, font.style, font.weight].filter(Boolean).join(' ');
      exists = fontString === fontCheck;
    }
  });
  return exists;
};

var getUnloadedFonts = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var emberUrl,
        finalFontsString,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            emberUrl = _args.length > 0 && _args[0] !== undefined ? _args[0] : _constants.STENCIL_FONT_CDN_URL;
            finalFontsString = [];
            _context.next = 4;
            return window.document.fonts.ready;

          case 4:
            // Wait for fonts to be loaded
            _constants.stencilFontProperties.forEach(function (fontProperty) {
              var fontCheck = [fontProperty.fontDisplay, fontProperty.fontFamily, fontProperty.fontStyle, fontProperty.fontWeight].filter(Boolean).join(' ');

              if (!fontExists(fontCheck)) {
                var fontRulesArray = [];
                fontRulesArray.push("font-family: '".concat(fontProperty.fontFamily, "';"));
                if (fontProperty.fontStyle) fontRulesArray.push("font-style: ".concat(fontProperty.fontStyle, ";"));
                if (fontProperty.fontWeight) fontRulesArray.push("font-weight: ".concat(fontProperty.fontWeight, ";"));
                fontRulesArray.push("src: url('".concat(emberUrl, "/").concat(fontProperty.filename, "') format('woff2');"));
                if (fontProperty.fontDisplay) fontRulesArray.push("font-display: ".concat(fontProperty.fontDisplay, ";"));
                var fontRules = fontRulesArray.join('\n');
                var appendedFontRule = "\n@font-face {\n".concat(fontRules, "\n}\n");
                finalFontsString.push(appendedFontRule);
              }
            });

            return _context.abrupt("return", finalFontsString.join(''));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getUnloadedFonts() {
    return _ref.apply(this, arguments);
  };
}();

exports.getUnloadedFonts = getUnloadedFonts;